import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, Collapse } from '@mui/material';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { QuoteModality } from 'src/utils/constants/quotes';

const EquipmentsAlert = ({ loading, equipments, distributor, modality }) => {
  const [open] = useState(true);
  const { t } = useTranslation();

  if (!loading && distributor) {
    if (!equipments.length) {
      if (modality && modality === QuoteModality.MSI) {
        return (
          <Collapse in={open}>
            <Alert severity="error">
              {t('EQUIPMENT_VIEW.CREATION_FORM.ALERT.NO_MSI_EQUIPMENTS_FIRST')}
              <Link to={`/distributors/business/${distributor.id}/catalog`}>
                {t(
                  'EQUIPMENT_VIEW.CREATION_FORM.ALERT.NO_MSI_EQUIPMENTS_SECOND'
                )}
              </Link>
            </Alert>
          </Collapse>
        );
      }
      return (
        <Collapse in={open}>
          <Alert severity="error">
            {t('EQUIPMENT_VIEW.CREATION_FORM.ALERT.NO_EQUIPMENTS_FIRST')}
            <Link to={`/distributors/business/${distributor.id}/catalog`}>
              {t('EQUIPMENT_VIEW.CREATION_FORM.ALERT.NO_EQUIPMENTS_SECOND')}
            </Link>
          </Alert>
        </Collapse>
      );
    }
  }

  return null;
};

export default EquipmentsAlert;

EquipmentsAlert.propTypes = {
  loading: PropTypes.bool.isRequired,
  equipments: PropTypes.array.isRequired,
  distributor: PropTypes.object.isRequired,
  modality: PropTypes.string
};
